<template>
  <a-modal
    v-model="visible"
    title="提示"
    okText="回到首页"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="info">
      <div>恭喜您，报名确认已全部完成</div>
    </div>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      type: 0,
    };
  },
  methods: {
    show(type) {
      this.visible = true;
      console.log(type);
      this.type = type;
    },
    handleOk() {
      this.$emit("next", this.type);
      this.handleCancel();
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.info {
  text-align: center;
  div {
    margin: 20px 0;
  }
}
</style>
